import '../../assets/components/Layout/Row.css';//#region lib/components/Layout/Row.module.css
var e = "_row_17lmw_1", t = { row: e };
//#endregion
export { t as default, e as row };
